import { Component, OnInit, ViewChild, inject, signal } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { Observable, Observer } from 'rxjs';
import { NgTemplateOutlet, NgClass, CurrencyPipe, DatePipe, JsonPipe } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { MatTableModule } from '@angular/material/table';
import { MatSort, MatSortModule } from '@angular/material/sort'
import { MATERIAL_MODULES } from '../../Common/material.config';
import { ColumnSelectorComponent } from 'src/app/Common/Components/material-list/column-selector/column-selector.component';

import { AbstractMarterialTableListWithFilter, IOptionsListFilter }
    from 'src/app/Common/Components/material-list/abstract-material-list-with-filters.class'
import { ModalWindowService } from 'src/app/Common/modal-window/modal-window.service';
import { AlumnisService, IAlumnisRecord } from 'src/app/Common/services/alumnis.service';
// import { AcreditacionService } from 'src/app/Common/services/acreditacion.service';
import { CustomerService, ICustomerLoginRecord } from 'src/app/Common/services/customer.service';
// import { FileUploadService } from 'src/app/Common/services/file-upload.service';
import { AlumnisEditComponent } from '../alumnis-edit/alumnis-edit.component'
import { TiposEmpresa } from 'src/app/Common/services/tipos-empresa';
import { MatPaginator } from '@angular/material/paginator';
@Component({
    selector: 'alumnis-list',
    templateUrl: './alumnis-list.component.html',
    standalone: true,
    imports: [
        ReactiveFormsModule, FormsModule, MatFormFieldModule, MatInputModule,
        NgTemplateOutlet, NgClass, DatePipe, JsonPipe,
        ...MATERIAL_MODULES,
        MatTableModule,
        MatSortModule,
        ColumnSelectorComponent
    ],
    styleUrls: [
        '../../Common/Components/material-list/material-list-abstract.component.scss',
        '../../Common/Components/material-list/abstract-material-list-with-filters.component.scss',
        './alumnis-list.component.scss'
    ]
})
export class AlumnisListComponent extends AbstractMarterialTableListWithFilter implements OnInit {
    private _AlumnisS = inject(AlumnisService);
    private _TiposEmpresaS = inject(TiposEmpresa);
    // private _AcreditacionS = inject(AcreditacionService);
    // private domSanitizer = inject(DomSanitizer);
    private _ModalWindowS = inject(ModalWindowService);
    private _CustomerS = inject(CustomerService);

    @ViewChild(MatPaginator) override paginator: MatPaginator | null = null;
    @ViewChild(MatSort) override sort: MatSort | null = null;
    @ViewChild('paginatorTop') paginator_top: MatPaginator | undefined = undefined;
    @ViewChild('paginatorBottom') paginator_bottom: MatPaginator | undefined = undefined;

    //Campos a personalizar:
    public default_displayed_columns = ['empresa', 'cargo', 'nombre', 'apellidos', 'email', 'telefono', 'command_cell'];
    public forbidden_columns = this._AlumnisS.forbidden_columns;
    public override displayed_column_filters: string[] = ['fempresa', 'fcargo', 'fnombre', 'fapellidos', 'femail', 'ftelefono', 'menu'];
    public override page_size_options = [10, 25, 50];

    public lista_empresas: IOptionsListFilter[] = [];
    public lista_tipo_incripciones: string[] = this._TiposEmpresaS.tipos_empresa_list;
    public current_customer: any;
    public upload_progress: number = 0;
    public file_name = '';
    public read_only = this._CustomerS.isOnlyRead();


    protected _data_source = this._AlumnisS;
    protected is_admin = this._CustomerS.isContentAdmin();
    public is_showing_all_alumnis = signal<boolean>(false);

    // =========================================================================
    // -------------------------------------------------------------------------
    constructor() {
        super();

        this.read_only = this._CustomerS.isOnlyRead();
        this.current_customer = this._CustomerS.value.id_usuario;
        this.forbidden_columns = this.serviceSource.forbidden_columns;

    }

    // -------------------------------------------------------------------------
    override ngOnInit(): void {

        if (this.is_admin) {
            super.ngOnInit();
        } else {
            // si no es admin no mostrar el dni
            this.all_columns = Object.keys(this._data_source.empty_record).filter(col => col !== 'dni');
            //        this._displayed_columns = this.default_displayed_columns;
            this._refreshListData();
            super.ngOnInit();
        }

    }

    // =========================================================================
    // -------------------------------------------------------------------------
    // -------------------------------------------------------------------------
    public onExportAllData(e: any): void {

        this._downloadCSV(e, this._JSON2CSV(this.list_data.data));

    }

    // -------------------------------------------------------------------------
    public onExportFilteredData(e: any) {

        this._downloadCSV(e, this._JSON2CSV(this.list_data.filteredData));

    }

    // =========================================================================
    // -------------------------------------------------------------------------
    // -------------------------------------------------------------------------
    public onEdit(table_row_info: IAlumnisRecord): void {
        let row = table_row_info;
        if (row.id_alumnis !== 0) {
            row = <IAlumnisRecord>this._AlumnisS.value_list.find(
                e => e.id_alumnis == table_row_info.id_alumnis
            );
        }

        const dialog_conf = {
            width: '100%',
            maxWidth: '80vw'
        };

        this._ModalWindowS.showComponent(
            AlumnisEditComponent,
            row,
            ['alumnis-edit'],
            dialog_conf
        ).subscribe({
            next: (data: IAlumnisRecord | null) => {
                if (data) {
                    this.serviceSource.save(data).subscribe(() => this._refreshListData());
                }
            },
            error: (e: HttpErrorResponse) => {
                console.error("Edit alumni error", e);
                if (e.status === 401) {
                    this._ModalWindowS.showMessageError(e.message);
                    this._CustomerS.submitLogout();
                }
            }
        });

    };

    // -------------------------------------------------------------------------
    public onCreateNew(): void {

        this.onEdit(this.serviceSource.empty_record);

    };

    // -------------------------------------------------------------------------
    public onDelete(row: IAlumnisRecord): void {
        this._ModalWindowS.showMessageConfirm('¿Está seguro que desea borrar este alumni?').subscribe((borrar: boolean) => {
            if (borrar) {
                this.serviceSource.delete(row).subscribe(
                    () => { this._refreshListData() }
                );
            }
        });

    };

    // -------------------------------------------------------------------------
    public readAllAlumnis(): void {

        this.is_showing_all_alumnis.set(true);
        AlumnisListComponent.resetFilters();

        this.serviceSource.readFilter({}).subscribe({
            next: (rows: IAlumnisRecord[]) => {

                this._AlumnisS.value_list = rows;
                this._setListaData(rows);

            },
            error: (e: HttpErrorResponse) => {
                if (e.status === 401) {
                    this._ModalWindowS.showMessageError(e.message);
                    this._CustomerS.submitLogout();
                } else {
                    this._ModalWindowS.showMessageError('Error leyendo datos: \n' + e.message);
                }
            }
        });

    }

    // -------------------------------------------------------------------------
    // -------------------------------------------------------------------------
    protected readListData(): Observable<any[]> {
        this.is_showing_all_alumnis.set(false);

        return new Observable<IAlumnisRecord[]>((obs: Observer<IAlumnisRecord[]>) => {
            this.serviceSource.readAlumnis().subscribe(
                (rows: IAlumnisRecord[]) => {
                    obs.next(rows);
                },
                (e: HttpErrorResponse) => {
                    if (e.status === 401) {
                        this._ModalWindowS.showMessageError(e.message);
                        this._CustomerS.submitLogout();
                    } else {
                        this._ModalWindowS.showMessageError('Error leyendo datos: \n' + e.message);
                    }
                    obs.error(e);
                }
            );
        });

    }

    // ---------------------------------------------------------------------------
    protected _afterReadData(row_read: any[]) {

        this.lista_empresas = [];

        // normalize("NFD") separa las tildes de los caracteres acentuados
        // .replace(/[\u0300-\u036f]/g, '') los elimina (los remplaza con '')
        this.lista_empresas.sort((e1, e2) =>
            e1.description.normalize("NFD").replace(/[\u0300-\u036f]/g, '').toUpperCase()
                >
                e2.description.normalize("NFD").replace(/[\u0300-\u036f]/g, '').toUpperCase() ? 1 : -1);

        this._initPaginatorBottom();
        // decodificar el valor del tipo de inscripción
        // this.list_data.data.forEach((e: any) => {
        //     e.tipo_inscripcion = this.lista_tipo_incripciones[e.tipo_inscripcion];
        // });

    }

    // -------------------------------------------------------------------------
    private _JSON2CSV(input: Object[]): string {
        let csv = '"' + Object.keys(input[0]).filter(e => !this.forbidden_columns.includes(e)).join('","') + '"\n';

        input.forEach((e: Object) => {
            for (const [key, value] of Object.entries(e)) {
                if (this.forbidden_columns.includes(key)) {
                    continue;
                }
                csv += '"' + (value ? value : '') + '",';
            }
            csv = csv.slice(0, -1) + '\n'
        });

        return csv;
    }

    // -------------------------------------------------------------------------
    // element is an html a tag which we are using to download de data
    // data is the csv data to download
    private _downloadCSV(element: any, csv_data: string): void {
        const prefix = 'data:text/plain;charset=utf-8,';
        const file_data = prefix + encodeURIComponent(csv_data);

        element.currentTarget.setAttribute('href', file_data);

    }


}
